import React from 'react';
import {CopyIcon} from "../icons";
import {useAlert} from "./Alert";
import {ALERT_TYPES} from "../../types";

interface IInfo {
  inn: string;
  phone: string;
  scoring: string
}

const Popover = ({ info }: { info: IInfo | null | undefined }) => {
  const { setAlert } = useAlert();
  const handleCopyText = (text: string) => {
    navigator.clipboard.writeText(text);
    setAlert('Скопировано в буфер обмена', ALERT_TYPES.SUCCESS);
  }

  return (
    <div className="w-[290px] py-4 px-2 bg-white rounded shadow-popover">
      <p className="text-mainBlack/75 text-xs">ИНН</p>
      <div className="flex items-center gap-1 mt-1">
        <span className="text-black text-sm leading-[16px] font-medium">{info?.inn}</span>
        <span onClick={() => handleCopyText(info ? info?.inn : '')}>
          <CopyIcon className="cursor-pointer hover:scale-110 duration-150 ease-in hover:stroke-gray" />
        </span>
      </div>
      <p className="text-mainBlack/75 text-xs mt-3">Скоринг</p>
      <div className="flex items-center gap-1 mt-1">
        <span className="text-black text-sm leading-[16px] font-medium">{info?.scoring}</span>
        <span onClick={() => handleCopyText(info ? info?.scoring : '')}>
          <CopyIcon className="cursor-pointer hover:scale-110 duration-150 ease-in hover:stroke-gray" />
        </span>
      </div>
      <p className="text-mainBlack/75 text-xs mt-3">Телефон</p>
      <div className="flex items-center gap-1 mt-1">
        <span className="text-black text-sm leading-[16px] font-medium">{info?.phone}</span>
        <span onClick={() => handleCopyText(info ? info?.phone : '')}>
          <CopyIcon className="cursor-pointer hover:scale-110 duration-150 ease-in hover:stroke-gray" />
        </span>
      </div>
    </div>
  )
};

export default Popover;
